import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';
import { IInvestSecondaryMarketProps } from 'models/api';

import { asyncPayloadCreator } from 'utils';

export const buySecondaryMarketItem = createAsyncThunk(
	'secondaryMarket/buySecondaryMarketItem',
	(params: IInvestSecondaryMarketProps, { rejectWithValue }) =>
		asyncPayloadCreator(params, { rejectWithValue }, SecondaryMarketService.buy),
);
